(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function wrapTables(content) {
    if (!content) return;

    content.querySelectorAll('table').forEach(function (table) {
      if (table.closest('.cba-table-scroll')) return;
      var wrapper = document.createElement('div');
      var colCount = table.rows[0] ? table.rows[0].cells.length : 0;
      wrapper.className = 'cba-table-scroll' + (colCount >= 4 ? ' cba-table-scroll--wide' : '');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
      if (colCount >= 4) table.classList.add('cba-table--wide');
    });
  }

  function collectHeadings(content) {
    var all = Array.from(content.querySelectorAll('h1, h2, h3, h4, h5, h6'));
    if (!all.length) return [];

    var preferredTags = ['H2', 'H3', 'H1'];
    for (var i = 0; i < preferredTags.length; i++) {
      var matched = all.filter(function (heading) {
        return heading.tagName === preferredTags[i];
      });
      if (matched.length) return matched;
    }

    return all;
  }

  function initToc(pcRoot) {
    var content = pcRoot.querySelector('.c27-article-pc__body[data-cba-content]');
    var tocList = pcRoot.querySelector('[data-cba-toc-list]');
    var indicator = pcRoot.querySelector('[data-cba-toc-indicator]');
    var track = pcRoot.querySelector('[data-cba-toc-track]');

    if (!content || !tocList) return;

    var headings = collectHeadings(content);
    tocList.innerHTML = '';

    if (!headings.length) return;

    var usedIds = {};
    var links = [];

    headings.forEach(function (heading, index) {
      var text = heading.textContent.trim();
      if (!text) return;

      var baseId = heading.id || slugify(text) || 'section-' + (index + 1);
      var id = baseId;
      var suffix = 1;

      while (usedIds[id] || document.getElementById(id)) {
        id = baseId + '-' + suffix;
        suffix += 1;
      }

      usedIds[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.className = 'c27-article-pc__toc-link';
      link.href = '#' + id;
      link.textContent = text;
      link.dataset.target = id;
      tocList.appendChild(link);
      links.push({ link: link, heading: heading });
    });

    if (!links.length) return;

    links[0].link.classList.add('is-active');

    links.forEach(function (item) {
      item.link.addEventListener('click', function (event) {
        event.preventDefault();
        item.heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + item.heading.id);
      });
    });

    function updateIndicator(activeLink) {
      if (!indicator || !track || !activeLink) return;
      var trackRect = track.getBoundingClientRect();
      var linkRect = activeLink.getBoundingClientRect();
      var offset = linkRect.top - trackRect.top;
      var height = Math.max(linkRect.height, 24);
      indicator.style.transform = 'translateY(' + offset + 'px)';
      indicator.style.height = height + 'px';
    }

    function setActive(index) {
      links.forEach(function (item, i) {
        item.link.classList.toggle('is-active', i === index);
      });
      updateIndicator(links[index].link);
    }

    if ('IntersectionObserver' in window) {
      var ratios = new Array(links.length).fill(0);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var idx = links.findIndex(function (item) {
              return item.heading === entry.target;
            });
            if (idx === -1) return;
            ratios[idx] = entry.intersectionRatio;
          });

          var bestIndex = 0;
          var bestRatio = -1;
          ratios.forEach(function (ratio, i) {
            if (ratio > bestRatio) {
              bestRatio = ratio;
              bestIndex = i;
            }
          });

          if (bestRatio >= 0) setActive(bestIndex);
        },
        {
          root: null,
          rootMargin: '-20% 0px -55% 0px',
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        }
      );

      links.forEach(function (item) {
        observer.observe(item.heading);
      });
    }

    updateIndicator(links[0].link);
    window.addEventListener('resize', function () {
      var active = tocList.querySelector('.c27-article-pc__toc-link.is-active');
      updateIndicator(active);
    });
  }

  function initFaq(content) {
    if (!content) return;

    content.querySelectorAll('.faq-section .faq-item').forEach(function (item) {
      if (item.dataset.cbaFaqBound === 'true') return;

      var question = item.querySelector('h3');
      var answer = item.querySelector('.faq-answer');
      if (!question || !answer) return;

      item.dataset.cbaFaqBound = 'true';

      if (!answer.querySelector('.cba-faq-panel')) {
        var panel = document.createElement('div');
        panel.className = 'cba-faq-panel';
        while (answer.firstChild) panel.appendChild(answer.firstChild);
        answer.appendChild(panel);
      }

      question.setAttribute('role', 'button');
      question.tabIndex = 0;

      function setOpen(next) {
        item.classList.toggle('is-open', next);
        item.classList.remove('open');
        question.setAttribute('aria-expanded', next ? 'true' : 'false');
      }

      setOpen(item.classList.contains('open') || item.classList.contains('is-open'));

      function toggle(event) {
        if (event.target.closest('a')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        setOpen(question.getAttribute('aria-expanded') !== 'true');
      }

      question.addEventListener('click', toggle);
      question.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setOpen(question.getAttribute('aria-expanded') !== 'true');
        }
      });
    });
  }

  function initBlogArticle(section) {
    section.querySelectorAll('[data-cba-content]').forEach(function (content) {
      wrapTables(content);
      initFaq(content);
    });

    var pcRoot = section.querySelector('.c27-article-pc');
    if (pcRoot) initToc(pcRoot);
  }

  function boot() {
    document.querySelectorAll('[data-section-type="c27-blog-article"]').forEach(initBlogArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="c27-blog-article"]');
    if (section) initBlogArticle(section);
  });
})();
